import React from "react";
import { Link } from "react-router-dom";
import { IdentityView } from "../../services/physicalIdentityApi";
import { useKT } from "../karkhana/i18n/kt";
import { scanDay } from "./ScanTimeline";
import StageMoveButton from "./StageMoveButton";

/**
 * Where a scanned piece is in its making, with the one next step. On View Product (opened from a label scan) it
 * sits above the fold for the making studio's owner; on the scan card it heads the supervisor's view. Only the
 * server's answer decides whether the move button shows (stripActionsAllowed for owners, primaryAction for
 * supervisors).
 */
export default function ScanStageStrip({ view, token, onMoved, showEdit }: { view: IdentityView; token: string; onMoved: () => void; showEdit?: boolean }) {
  const { t } = useKT();
  const stage = view.stage;
  if (!stage) return null;
  const weaving = view.timeline?.weaving;
  const action = view.primaryAction;
  const canMove = view.viewerRole === "MAKER_OWNER" ? Boolean(view.stripActionsAllowed) && action?.kind === "MOVE_STAGE" : action?.kind === "MOVE_STAGE";
  const pieceName = view.card?.sareeNumber ? t("Saree {{n}}", { n: view.card.sareeNumber }) : view.card?.name || view.title || t("this piece");
  const sold = view.state?.commerceState === "SOLD" || view.state?.lifecycle === "CUSTOMER_COLLECTION";
  const where = stage.onLoom
    ? t("Weaving on loom {{loom}}", { loom: view.card?.loomCode || "" })
    : stage.currentLabel ? t(stage.currentLabel) : t("No stage recorded yet");
  return <section className="scan-strip" aria-label={t("Making stage")}>
    <div className="scan-strip__now">
      <p className="scan-eyebrow">{t("Stage")}</p>
      <p className="scan-strip__stage">{where}</p>
      <p className="scan-meta">
        {stage.onLoom && weaving ? t("{{woven}} of {{full}} m woven", { woven: weaving.wovenMetres, full: weaving.fullMetres })
          : stage.currentSince ? t("since {{day}}", { day: scanDay(stage.currentSince) }) : null}
        {sold ? ` · ${t("Finished · left the karkhana")}` : null}
      </p>
    </div>
    {canMove && <StageMoveButton token={token} stage={stage} pieceName={pieceName} onMoved={onMoved} />}
    {action?.kind === "RECORD_LOOM_WORK" && action.href && <Link className="scan-btn is-primary is-move" to={action.href}>
      {t("Add today’s work on Loom {{loom}}", { loom: action.loomCode || "" })}
    </Link>}
    {!canMove && action?.kind !== "RECORD_LOOM_WORK" && !stage.next && stage.current === "COMPLETED" && <span className="scan-chip is-ok">{t("Finished")}</span>}
    {showEdit && <Link className="scan-strip__edit" to="/physical-identities/stages">{t("Edit stages")}</Link>}
  </section>;
}
